<template>
  <div class="wysiwyg">
    <p v-for="(paragraph, index) in aftercareDescription" :key="index">
      {{ paragraph }}
    </p>
  </div>

  <ul v-if="aftercareItems.length > 0" class="aftercare__icons">
    <li v-for="item in aftercareItems" :key="item.value">
      <i class="icon" :class="`icon-${item.icon}`" />
      {{ item.value }}
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Aftercare",
  computed: {
    ...mapState("product", ["product"]),
    aftercareDescription() {
      if (!this.product.aftercareDescription) return null;
      const str = this.product.aftercareDescription.value;
      const paragraphs = str.split(/\r?\n/);
      return paragraphs;
    },
    aftercareItems() {
      const aftercareBooleans = {
        dryCleanOnly: this.product.dryCleanOnly?.value === "true",
        doNotBleach: this.product.doNotBleach?.value === "true",
        doNotDryClean: this.product.doNotDryClean?.value === "true",
        handWashAt30Degrees: this.product.handWashAt30Degrees?.value === "true",
        handWashInColdWater: this.product.handWashInColdWater?.value === "true",
        washAt30Degrees: this.product.washAt30Degrees?.value === "true",
        ironAtLowTemperature:
          this.product.ironAtLowTemperature?.value === "true",
        doNotTumbleDry: this.product.doNotTumbleDry?.value === "true",
        doNotIron: this.product.doNotIron?.value === "true",
        doNotSteam: this.product.doNotSteam?.value === "true",
        doNotIronOrSteam: this.product.doNotIronOrSteam?.value === "true",
      };

      const aftercareIcons = {
        dryCleanOnly: {
          icon: "dry-clean",
          value: "Dry clean only",
        },
        doNotBleach: {
          icon: "no-bleach",
          value: "Do not bleach",
        },
        doNotDryClean: {
          icon: "no-dry-clean",
          value: "Do not dry clean",
        },
        handWashAt30Degrees: {
          icon: "hand-wash-30",
          value: "Hand wash at 30 degrees",
        },
        handWashInColdWater: {
          icon: "hand-wash-cold",
          value: "Hand wash in cold water",
        },
        washAt30Degrees: {
          icon: "wash-30",
          value: "Wash at 30 degrees or less",
        },
        ironAtLowTemperature: {
          icon: "iron-low-temp",
          value: "Iron at low temperature",
        },
        doNotTumbleDry: {
          icon: "no-tumble-dry",
          value: "Do not tumble dry",
        },
        doNotIron: {
          icon: "no-iron",
          value: "Do not iron",
        },
        doNotSteam: {
          icon: "no-steam",
          value: "Do not steam",
        },
        doNotIronOrSteam: {
          icon: "no-iron-or-steam",
          value: "Do not iron or steam",
        },
      };

      const aftercare = Object.entries(aftercareBooleans)
        .filter(([, value]) => value === true)
        .map(([key]) => ({
          icon: aftercareIcons[key].icon,
          value: aftercareIcons[key].value,
        }));

      return aftercare;
    },
  },
};
</script>

<style lang="scss" scoped>
.aftercare__icons {
  margin-top: 29px;

  li {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    @include utility-body(14px);
    color: $color-grey-dark;
  }

  .icon {
    width: 26px;
    margin-right: 16px;
    font-size: 26px;
    display: inline-block;
    color: $color-black;
  }
}

.wysiwyg p {
  @include editorial-body(20px);
}
</style>
